import { NavItem, TabNav } from "@mobiscroll/react";
import React, { Fragment, useMemo } from "react";
import { Helmet } from "react-helmet";
import { Card } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import allInvoice from "src/assets/all-invoice.svg";
import invoiceDetailSvg from "src/assets/invoice-purple.svg";
import Loader from "src/components/Dashboard/common/Loader";
import Invoice from "./Invoice";
import "./Invoice.scss";
import PDFViewer from "src/components/Dashboard/Layouts/PDFViewer";
import { useState } from "react";
import { isMobileOnly } from "react-device-detect";
import dayjs from "dayjs";

import useInvoicePdf from "../Patient/PatientDetail/DownloadInvoice";
const { Header: CardHeader, Body: CardBody, Title: CardTitle } = Card;

function InvoiceDetail(props) {

  const { id } = useParams();

  const {
    // downloadInvoice,
    isInvoiceLoading,
    invoiceData,
    subTotal,
    total,
    tax,
    invoiceBase64,
    fetchInvoiceData,
    invoiceFileName,
  } = useInvoicePdf(id);

  const history = useHistory();
  const [activeTab, setActiveTab] = React.useState("invoice-detail");
  const [showPDF, setShowPDF] = useState(false);

  React.useEffect(() => {
    fetchInvoiceData();
  }, [id]);

  // Memoize the invoice items for stable rendering
  const invoiceItems = useMemo(() => invoiceData?.items || [], [invoiceData]);

  const tableStyle = {
    border: "1px solid #ccc",
    textAlign: "left",
    padding: "6px 12px"
  }

  return activeTab === "invoice-detail" ? (
    <Fragment>
      <Helmet>
        <title>Invoice Detail | DOCG</title>
      </Helmet>
      <PDFViewer
        link={invoiceBase64}
        show={showPDF}
        setShow={setShowPDF}
        fileName={invoiceFileName}
      />
      <Loader show={isInvoiceLoading} />
      {/* Main Content start Here  */}
      <Card className="docg-card docg-appointment docg-invoice patient-wrapper card-wrapper mt-0 mb-0">
        <CardHeader className="docg-card-header pb-0 customHeader d-flex justify-content-between align-items-center">
          <TabNav className="docg-tabs" theme="windows" context="#tab-content">
            <NavItem
              selected={activeTab === "allinvoice"}
              onClick={() => {
                history.push("/invoice");
                setActiveTab("allinvoice");
              }}

            >
              <img src={allInvoice} alt="" />
              <span style={isMobileOnly ? { fontSize: "0.8rem" } : {}}>All Invoices</span>
            </NavItem>
            <NavItem selected={activeTab === "invoice-detail"} onClick={() => setActiveTab("invoice-detail")}>
              <img src={invoiceDetailSvg} alt="" />
              <span style={isMobileOnly ? { fontSize: "0.8rem" } : {}}>Invoice Detail</span>
            </NavItem>
          </TabNav>
          <div className="d-flex justify-content-end align-items-center">
            {invoiceBase64 && !isInvoiceLoading && (
              <button onClick={async () => { setShowPDF("invoice"); }} className="docg-outline-btn" style={isMobileOnly ? { fontSize: "0.8rem", padding: "2px 4px" } : {}}>
                View Invoice
              </button>
            )}
          </div>
        </CardHeader>

        <CardBody className="docg-card-body px-4">
          <div>
            <p className="purple-bold mt-2 mb-2">Invoice To</p>
            <div className="mbsc-row mt-4 gap-4">
              <div className="col-lg-3" style={{ borderRight: "2px solid #d4859c" }}>
                <span><b>Patient Name :</b></span>&nbsp;&nbsp;{invoiceData?.to}
              </div>
              <div className="col-lg-3 pl-4" style={{ borderRight: "2px solid #d4859c" }}>
                <span><b>Date & Time :</b></span>&nbsp;&nbsp;{dayjs(invoiceData?.createdAt).format('MMM D, YYYY h:mm A')}
              </div>
              <div className="col-lg-3 pl-4">
                <span><b>Invoice No :</b></span>&nbsp;&nbsp;{invoiceData?.uhid}
              </div>
            </div>

            <div className="mbsc-row mt-2 gap-4">
              <div className="col-lg-3" style={{ borderRight: "2px solid #d4859c" }}>
                <span><b>Payment Mode :</b></span>&nbsp;&nbsp;{invoiceData?.paymentMethod}
              </div>
              <div className="col-lg-3 pl-4" style={{ borderRight: "2px solid #d4859c" }}>
                <span><b>Transaction ID :</b></span>&nbsp;&nbsp;{invoiceData?.transactionId || "Not Available"}
              </div>
              <div className="col-lg-3 pl-4">
                <span><b>Status :</b></span>&nbsp;&nbsp;{invoiceData?.status}
              </div>
            </div>

            <hr className="mt-4" />

            {/* html table for invoice items */}
            {invoiceItems.length > 0 && (
              <div className="mt-4">
                <div className="mt-4">
                  <table style={{ width: "90%", borderCollapse: "collapse", margin: "auto" }}>
                    <thead>
                      <tr>
                        <th style={tableStyle}>SN.</th>
                        <th style={tableStyle}>Description</th>
                        {!isMobileOnly && <th style={tableStyle}>Type</th>}
                        {!isMobileOnly && <th style={tableStyle}>CGST</th>}
                        {!isMobileOnly && <th style={tableStyle}>SGST</th>}
                        <th style={tableStyle}>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceItems.map((item, index) => (
                        <tr key={index}>
                          <td style={tableStyle}>{index + 1}</td>
                          <td style={tableStyle}>{item.description}</td>
                          {!isMobileOnly && <td style={tableStyle}>{item.type}</td>}
                          {!isMobileOnly && <td style={tableStyle}>{item.cgst}</td>}
                          {!isMobileOnly && <td style={tableStyle}>{item.sgst}</td>}
                          <td style={tableStyle}>&#8377; {item.amount?.toLocaleString("en-IN")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <hr className="my-4" />
              </div>
            )}

            {/* sub total, tax, total  */}
            <div className="row add-bottom-border d-flex justify-content-end pb-4">
              <div className="d-flex flex-column align-items-end">
                <div className="d-flex align-items-center total-amount-wrapper">
                  <p className="total-tax">Sub Total :</p>
                  <p className="total-amount-tax">
                    &#8377; {subTotal?.toLocaleString("en-IN")}
                  </p>
                </div>
                <div className="d-flex align-items-center total-amount-wrapper">
                  <p className="total-tax">Tax :</p>
                  <p className="total-amount-tax">
                    &#8377; {tax?.toLocaleString("en-IN")}
                  </p>
                </div>
                <div className="d-flex align-items-center total-amount-wrapper">
                  <p className="total-tax">Total :</p>
                  <p className="total-amount-tax">
                    &#8377; {total?.toLocaleString("en-IN")}
                  </p>
                </div>
              </div>
            </div>

            <div className="signature-div">
              <img src={invoiceData?.signature} alt="" height={70} />
              <b>Dr. {invoiceData?.doctorName}</b>
            </div>

          </div>
        </CardBody>
      </Card>
    </Fragment>
  ) : (
    <Invoice />
  );
}

export default InvoiceDetail;
